import React, { useState } from 'react';

import { Button, ModalHeader, ModalFooter, ModalBody, List, ListItem, Typography, TextField } from '@cfa/react-components';
import { DeviceService, parseAxiosError } from "services";
import toast from "react-hot-toast";
import { IDevice } from 'interfaces';

interface IDeleteModalProps {
    devices: IDevice[],
    onHide: () => void,
    refresh: () => void,
}

export function DeleteModal({ devices, onHide, refresh }: IDeleteModalProps) {

    const [loading, setLoading] = useState(false);
    const [confirmValue, setConfirmValue] = useState("");
    const confirmPhrase = "delete me";

    const deleteDevice = () => {
        
        setLoading(true);

        DeviceService.batchDeleteDevices(devices)
            .then(() => {
                refresh();
                onHide();
                if (devices.length == 1) toast.success("Device Deleted");
                else toast.success("Devices Deleted");
            })
            .catch((err) => {
                onHide();
                toast.error(parseAxiosError(err));
                setLoading(false);
            });
    }

    return (<>

        <ModalHeader>
            {"Delete "} {devices.length > 1 ? "Devices?" : "Device?"}
        </ModalHeader>

        <ModalBody>
            <List>
                {devices.length < 10 && devices.map((d) => <ListItem>
                    {d.thingID}
                </ListItem>)}
            </List>
            <TextField
                label={'Enter "' + confirmPhrase + '" to confirm'}
                value={confirmValue}
                onChange={(e) => setConfirmValue(e.target.value)}
                placeholder={confirmPhrase}
            />
        </ModalBody>

        <ModalFooter>
            <Button variant="outlined" onClick={onHide}>
                Close
            </Button>
            <Button
                variant="filled"
                onClick={deleteDevice}
                loading={loading}
                disabled={confirmValue !== confirmPhrase}
            >
                {loading ? 'Deleting...' : 'Confirm'}
            </Button>
        </ModalFooter>

    </>);
}